function displayTotalRecords(total) {
    const totalRecordsDiv = $('#DXrapnettotalRecords');
    totalRecordsDiv.text(`Toplam Kayıt Sayısı: ${total}`);
}

function setupPagination(totalItems) {
    totalPages = Math.ceil(totalItems / mongolimit);
    displayTotalRecords(totalItems);
    currentPage = Math.min(Math.max(currentPage, 1), totalPages);

    const paginationDiv = $('#pagination');
    paginationDiv.empty();

    const prevDisabled = currentPage === 1 ? "disabled" : "";
    paginationDiv.append(`<button ${prevDisabled} onclick="changePage(currentPage - 1)">Önceki</button>`);

    if (totalPages <= 7) {
        for (let i = 1; i <= totalPages; i++) {
            paginationDiv.append(`<button onclick="changePage(${i})">${i}</button>`);
        }
    } else {
        const startRange = Math.max(currentPage - 2, 2);
        const endRange = Math.min(currentPage + 2, totalPages - 1);

        paginationDiv.append(`<button onclick="changePage(1)">1</button>`);
        if (startRange > 2) {
            paginationDiv.append(`<span>...</span>`);
        }

        for (let i = startRange; i <= endRange; i++) {
            paginationDiv.append(`<button onclick="changePage(${i})">${i}</button>`);
        }

        if (endRange < totalPages - 1) {
            paginationDiv.append(`<span>...</span>`);
        }

        paginationDiv.append(`<button onclick="changePage(${totalPages})">${totalPages}</button>`);
    }

    const nextDisabled = currentPage === totalPages ? "disabled" : "";
    paginationDiv.append(`<button ${nextDisabled} onclick="changePage(currentPage + 1)">Sonraki</button>`);

    updatePaginationButtons(currentPage);
}


function changePage(newPage) {
    currentPage = newPage;
    fetchDiamonds(currentPage);
}

function updatePaginationButtons(activePage) {
    $('#pagination button').removeClass('active');
    $('#pagination button').each(function() {
        const pageNumber = parseInt($(this).text()) || 0;
        if (pageNumber === activePage) {
            $(this).addClass('active');
        }
    });

    $('#pagination button:contains("Önceki")').prop('disabled', activePage === 1);
    $('#pagination button:contains("Sonraki")').prop('disabled', activePage === totalPages);
}

function updateSortIcons(clickedHeader) {
    // Tüm sütunlardan sınıfları kaldır ve sadece tıklanan sütuna sınıf ekle
    $('#diamondsTable th').removeClass('asc desc');
    const orderClass = sortOrder === '1' ? 'asc' : 'desc';
    clickedHeader.addClass(orderClass);
}